module.exports = __webpack_public_path__ + "static/img/voluntainer.3fafd3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tmf/voluntainer.svg
// module id = fZqR
// module chunks = 1